/* Which stage a word is at, and which games can use it.
 * Pure functions of a card: no state import, so state.js may use them. */

import { MET } from './constants.js';
import { cloze, pluralForm } from './text.js';

export function stage(c){
  if(!c.reps) return 0;
  if(c.sk.rec<MET) return 1;
  if(c.art && c.sk.gen<MET) return 2;
  if(c.sk.pro<MET) return 3;
  if(c.sk.app<MET) return 4;
  return c.interval>=21?5:4;
}

export const ELIG={
  artikel:c=>c.pos==="n"&&!!c.art,
  plural:c=>c.pos==="n"&&!!pluralForm(c),
  salat:c=>c.term.indexOf(" ")<0&&c.term.length<=13,
  luecke:c=>!!cloze(c),
  hoeren:()=>true, paare:()=>true, wahr:()=>true, schnell:()=>true, tippen:()=>true, blasen:()=>true
};

